exports.components = {
  "component---src-pages-editor-js": () => import("./../../../src/pages/editor.js" /* webpackChunkName: "component---src-pages-editor-js" */),
  "component---src-templates-storyblok-entry-tsx": () => import("./../../../src/templates/storyblok-entry.tsx" /* webpackChunkName: "component---src-templates-storyblok-entry-tsx" */)
}

